// @flow

import React, { type Node } from 'react';
import { usePendingIncomingPayment, getGatewayVoucherCode } from '@tectonics/prs/incoming-payment';
import { timesGroupSplitter } from '@tectonics/look-and-feel/commons/format-utils';
import styled from 'styled-components';

type DisplayBarcodeNumberProps = {|
  redesign?: boolean,
|};

export function DisplayBarcodeNumber({redesign = null}: DisplayBarcodeNumberProps): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <VoucherNumberWrapper redesign={redesign}>
      {timesGroupSplitter(4, getGatewayVoucherCode(incomingPayment)).map((code, index) => (
        <VoucherNumber key={index} redesign={redesign}>{code}</VoucherNumber>
      ))}
    </VoucherNumberWrapper>
  );
}

const VoucherNumberWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${props => props.redesign === true ? 'width:75%;margin-left:auto;margin-right:auto;' : 'width:100%;'}
`;

const VoucherNumber = styled.span`
  margin: 1%;
  font-size: ${props => props.redesign === true ? '1.2em' : '1em'};
  font-weight: ${props => props.redesign === true ? 900 : 500};
  color: #212b36;
  letter-spacing: 1px;
  text-align: center;
  background-color: ${props => props.redesign === true ? props.theme.colors.terciaryGray : props.theme.colors.primary(95)};
  border-radius: 5px;
  flex-basis: 23%;
`;
